<template>
    <div class="ownClassManagement">
        <div class="user-info-list-body">
            <div>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add">添加提示</el-button>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 20px;">
                <el-tab-pane label="C++" name="first">
                    <div class="table-style">
                        <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
                            <el-table-column prop="subjectName" label="科目"></el-table-column>
                            <el-table-column prop="created_time" label="创建时间"></el-table-column>
                            <el-table-column prop="text" label="关键词"></el-table-column>
                            <el-table-column prop="displayText" label="显示词"></el-table-column>
                            <el-table-column prop="displayInfo" label="提示信息"></el-table-column>
                            <el-table-column align="center" label="操作" width="150px" fixed="right">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="text" @click=edit(scope.row)>编辑</el-button>
                                    <el-button size="mini" type="text" @click="del(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="Pytion" name="second">
                    <div class="table-style">
                        <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
                            <el-table-column prop="subjectName" label="科目"></el-table-column>
                            <el-table-column prop="created_time" label="创建时间"></el-table-column>
                            <el-table-column prop="text" label="关键词"></el-table-column>
                            <el-table-column prop="displayText" label="显示词"></el-table-column>
                            <el-table-column prop="displayInfo" label="提示信息"></el-table-column>
                            <el-table-column align="center" label="操作" width="150px" fixed="right">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="text" @click=edit(scope.row)>编辑</el-button>
                                    <el-button size="mini" type="text" @click="del(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>

            </el-tabs>

            <div class="pagination-style">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no"
                    layout="total, prev, pager, next" :total="total" :page-size="page_size"></el-pagination>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <el-form ref="form" :model="form" label-width="90px">
                <el-form-item label="关键词">
                    <el-input v-model="form.text" @change="$forceUpdate()"></el-input>
                </el-form-item>
                <el-form-item label="显示词">
                    <el-input v-model="form.displayText" @change="$forceUpdate()"></el-input>
                </el-form-item>
                <el-form-item label="提示信息">
                    <el-input v-model="form.displayInfo" @change="$forceUpdate()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import { adminCreateOrUpdateEditorRemark, adminGetEditorRemark, adminDeleteEditorRemark } from "@/api/admin";
// import {
//     getCurriculumList,
// } from "@/api/educational";

export default {
    name: "platform-curriculum",
    data() {
        return {
            activeName: 'first',
            form: {
                id: '',
                subject_id: '4',
                text: '',
                displayText: '',
                displayInfo: '',
            },
            ruleForm: {
                subject_id: "4",
            },
            dialogVisible: false,
            tableData: [],
            total: 0,
            page_no: 1,
            page_size: 1000,
        };
    },
    mounted() {
        this.adminGetEditorRemark();
    },
    methods: {
        del(row) {
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                adminDeleteEditorRemark({
                    id: row.id
                }).then((res) => {
                    console.log(res);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.adminGetEditorRemark();

                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleClick(tab) {
            console.log(tab.name);
            if (tab.name === 'first') {
                this.ruleForm.subject_id = '4'
                this.adminGetEditorRemark()
            } else {
                this.ruleForm.subject_id = '3'
                this.adminGetEditorRemark()
            }
        },
        add() {
            console.log(this.activeName, 1212);
            this.form = {}
            if (this.activeName === 'first') {
                this.form.subject_id = '4'
            } else {
                this.form.subject_id = '3'
            }
            this.dialogVisible = true
        },
        edit(row) {
            console.log(row, 1212);
            this.form.subject_id = row.subject_id
            this.form.text = row.text
            this.form.displayText = row.displayText
            this.form.displayInfo = row.displayInfo
            this.form.id = row.id
            this.dialogVisible = true

        },
        submit() {
            if (this.form.id === '') {
                adminCreateOrUpdateEditorRemark({
                    subject_id: this.form.subject_id,
                    text: this.form.text,
                    displayText: this.form.displayText,
                    displayInfo: this.form.displayInfo,
                }).then((res) => {
                    console.log(res);
                    this.$message.success('添加成功')
                    this.adminGetEditorRemark()
                    this.dialogVisible = false
                })
            } else {
                adminCreateOrUpdateEditorRemark({
                    id: this.form.id,
                    subject_id: this.form.subject_id,
                    text: this.form.text,
                    displayText: this.form.displayText,
                    displayInfo: this.form.displayInfo,
                }).then((res) => {
                    console.log(res);
                    this.$message.success('编辑成功')
                    this.adminGetEditorRemark()
                    this.dialogVisible = false
                })
            }

        },
        // 获取课程体系
        adminGetEditorRemark() {
            adminGetEditorRemark(
                {
                    subject_id: this.ruleForm.subject_id,
                    page_no: this.page_no,
                    page_size: this.page_size,
                },
                true
            ).then((res) => {

                this.tableData = res.editorRemarkList.sort((a, b) => a.text.localeCompare(b.text));
                this.total = res.total;
                console.log(this.tableData);
            });
        },
        search() {
            this.page_no = 1;
            this.adminGetEditorRemark();
        },
        handleCurrentChange(val) {
            this.page_no = val;
            this.adminGetEditorRemark();
        },
        // 删除课程体系

    },
};
</script>
  
<style lang="scss" scoped>
.ownClassManagement {
    .user-info-list-body {
        margin: 10px;
        padding: 15px;
        background-color: #ffffff;
        border-radius: 5px;

        .label-title {
            font-size: 14px;
        }

        .search-list {
            margin-top: 20px;
            display: inline-block;
            margin-left: 20px;
        }
    }
}
</style>
  